import React, { useEffect } from 'react';
import { Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import { infoFormatterIntl } from '../../../utils/formatters';
import './authorized.scss';
import { Accordion } from '../../../components/base/Accordion/Accordion';

export function UserPersonalDataView(props) {
  const { user = {} } = props;

  const {
    formatMessage,
  } = intlShape;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="f3">{formatMessage({ id: 'user.profile.menu.personal' })}</div>
        <div className="f4 export-title">
          Экспорт данных
        </div>
      </div>
      <div className="mb-3" />
      <Row className="row-cols-3">
        {infoFormatterIntl('last_name', user?.last_name, {}, 'user.last_name')}
        {infoFormatterIntl('first_name', user?.first_name, {}, 'user.first_name')}
        {infoFormatterIntl('middle_name', user?.middle_name, {}, 'user.middle_name')}
      </Row>
      <div className="mb-2" />
      <Row className="row-cols-3">
        {infoFormatterIntl('birth_date', user?.birth_date, {}, 'user.birth_date')}
        {infoFormatterIntl('legal_entity_type', user?.legal_entity_type, {}, 'user.legal_entity_type')}
        {infoFormatterIntl('gender', user?.gender, {}, 'user.gender')}
      </Row>
      <div className="mb-2" />
      <Row className="row-cols-3">
        {infoFormatterIntl('snils', user?.snils, {}, 'user.snils')}
        {infoFormatterIntl('inn', user?.inn, {}, 'user.inn')}
        {infoFormatterIntl('citizenship', user?.citizenship, {}, 'user.citizenship')}
      </Row>
      <div className="mb-2" />
      <Row className="row-cols-1">
        {infoFormatterIntl('phone', user?.phone, {}, 'user.phone')}
      </Row>
      <div className="mb-2" />
      <Row className="row-cols-1">
        {infoFormatterIntl('pd.email', user?.email, {}, 'user.email')}
      </Row>
      <div className="mb-2" />
      <Row className="row-cols-1">
        {infoFormatterIntl('address_registration_entrepreneur', user?.registration_address, {}, 'user.registration_address')}
      </Row>
      <div className="mb-2" />
      <Row className="row-cols-1">
        {infoFormatterIntl('address', user?.residence_address, {}, 'user.address')}
      </Row>
      <div className="mb-4" />
      <Accordion
        title={formatMessage({ id: 'user.profile.additional.data' })}
        content={(
          <Row className="row-cols-2">
            {infoFormatterIntl('user.temporary_registration', user?.temporary_registration, {}, 'user.temporary_registration')}
            {infoFormatterIntl('user.stay_registration', user?.stay_registration, {}, 'user.stay_registration')}
          </Row>
        )}
      />
      <Accordion
        title={formatMessage({ id: 'user.profile.driver.license' })}
        content={(
          <Row className="row-cols-4">
            {infoFormatterIntl('driver_license_number', user?.driver_license?.number, {}, 'user.driver_license_number')}
            {infoFormatterIntl('driver_license_issue_date', user?.driver_license?.issue_date, {}, 'user.driver_license_issue_date')}
            {infoFormatterIntl('driver_license_expiration_date', user?.driver_license?.expiry_date, {}, 'user.driver_license_expiration_date')}
            {infoFormatterIntl('user.driver_license_categories', user?.driver_license?.categories, {}, 'user.driver_license_categories')}
          </Row>
        )}
      />
    </>
  );
}
